import { useRbSystemAlert, type RbTableRowId } from "@scmlatam/web-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { reportService } from "../services/service";

const useUndoConfirm = (
  reload: () => Promise<void>,
  selectedRowIds: Set<RbTableRowId>,
) => {
  const { t } = useTranslation("execute_report.confirm_undo_execute");
  const { showAlert, closeAlert } = useRbSystemAlert();

  const [open, setOpen] = useState<boolean>(false);

  const undoExecution = async () => {
    reportService.deleteResult({
      alert: { t, showAlert, closeAlert },
      params: {
        setLoading: () => {},
        reload,
        closing: () => {
          setOpen(false);
        },
        body: {
          where_delete: {
            id: Array.from(selectedRowIds),
          },
        },
      },
    });
  };

  return {
    t,
    open,
    setOpen,
    undoExecution,
  };
};

export { useUndoConfirm };
